import { AfterViewInit, Component, Input, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, ValidationErrors } from "@angular/forms";

/**
 * Generated class for the FrequencyInputComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "frequency-input",
  templateUrl: "frequency-input.html",
})
export class FrequencyInputComponent implements OnInit, AfterViewInit {
  // Configuration properties
  @Input() group: FormGroup;
  @Input() config;

  id: string;
  componentId: string;
  label: any;
  innerGroup: FormGroup;
  required: boolean;
  min: number;
  max: number;
  disabled: boolean;
  readonly: boolean = false;

  numeratorConfig: any;
  denominatorConfig: any;
  unitConfig: any;

  fieldTracker: object = {};

  constructor(public formBuilder: FormBuilder) {}

  ngOnInit(): void {
    this.id = this.config.id;
    this.componentId = this.config.componentId;
    this.label =
      this.config.label !== undefined ? this.config.label : this.config.id;
    if (this.label === "false") {
      this.label = false;
    }
    this.readonly = this.config.readonly;

    if (this.config.rules) {
      this.required = this.config.rules.required;
      delete this.config.rules.required;

      this.min = this.config.rules.min;
      delete this.config.rules.min;

      this.max = this.config.rules.max;
      delete this.config.rules.max;
    }

    this.numeratorConfig = {
      id: "numerator",
      componentId: this.componentId + "Numerator",
      label: false,
      rules: this.config.rules,
      readonly: this.readonly,
    };

    this.denominatorConfig = {
      id: "denominator",
      componentId: this.componentId + "Denominator",
      label: false,
      rules: this.config.rules,
      readonly: this.readonly,
    };

    this.unitConfig = {
      id: "timeUnit",
      componentId: this.componentId + "Unit",
      label: false,
      placeholder: "select",
      options: this.config.options,
      readonly: this.readonly,
    };

    this.group.addControl(this.id, this.formBuilder.control(null));

    // Inner form state
    this.innerGroup = this.formBuilder.group({});
    this.innerGroup.addControl("numerator", this.formBuilder.control(null));
    this.innerGroup.addControl("denominator", this.formBuilder.control(null));
    this.innerGroup.addControl("timeUnit", this.formBuilder.control(null));
    // this.innerGroup.controls['denominator'].setValue( 1 );

    this.group.controls[this.id].valueChanges.subscribe((data) => {
      this.loadState(data);
    });

    this.innerGroup.valueChanges.subscribe((data) => {
      // Field tracker is used to make sure that we don't warn about fields until they have been modified
      // Should be replaced w/ inner group dirty state, but that was being finicky
      for (let key of Object.keys(data)) {
        if (
          !this.fieldTracker[key] &&
          data[key] !== undefined &&
          data[key] !== null
        ) {
          // console.log( "Setting field tracker: ", key, data[key] );
          this.fieldTracker[key] = true;
        }
      }

      data = this.checkDataValidationBeforeSettingValues(data);

      this.group.controls[this.id].setValue(data);
      this.group.controls[this.id].setErrors(this.getErrors());
    });

    this.loadState(this.group.controls[this.id].value);
  }

  checkDataValidationBeforeSettingValues(data) {
    if (data != null && data != undefined) {
      if (data.numerator != null && data.numerator != undefined) {
        if (this.min) {
          if (data.numerator < this.min) {
            data.numerator = null;
          }
        }

        if (this.max) {
          if (data.numerator > this.max) {
            data.numerator = null;
          }
        }
      }

      if (data.denominator != null && data.denominator != undefined) {
        if (this.min) {
          if (data.denominator < this.min) {
            data.denominator = null;
          }
        }

        if (this.max) {
          if (data.denominator > this.max) {
            data.denominator = null;
          }
        }
      }
    }

    return data;
  }

  ngAfterViewInit(): void {
    this.group.controls[this.id].setErrors(this.getErrors());

    // Errors can get lost when manually set
    // This is an overzealous approach to guarantee they get maintained
    this.group.valueChanges.subscribe((data) => {
      this.group.controls[this.id].setErrors(this.getErrors());
    });
  }

  loadState(data) {
    // console.log( "Outer group (frequency -> " + this.id + ") change:", data );
    let innerGroup = this.innerGroup;
    if (data === null) {
      innerGroup.setValue({
        numerator: null,
        denominator: null,
        timeUnit: null,
      });
    } else if (data !== undefined && data !== innerGroup.value) {
      data = this.checkDataValidationBeforeSettingValues(data);
      innerGroup.setValue(data);
    }

    let outerDisabled = this.group.controls[this.id].disabled;
    if (outerDisabled !== this.disabled) {
      this.disabled = outerDisabled;
      if (!this.disabled) {
        this.innerGroup.enable();
      } else {
        this.innerGroup.disable();
      }
    }
  }

  getErrors(): ValidationErrors {
    let errors = {};

    if (!this.disabled) {
      let innerControls = this.innerGroup.controls;
      for (let key of Object.keys(innerControls)) {
        let control = innerControls[key];
        let value = control.value;

        // console.log( "Validating: ", key, value );

        if (
          this.required &&
          (value == undefined || value == null || value === "")
        ) {
          if (!errors["missingValue"]) {
            errors["missingValue"] = key;
          }
          continue;
        }

        if (
          key == "numerator" &&
          this.fieldTracker[key] &&
          value !== null &&
          value !== undefined
        ) {
          if (this.min !== undefined && value < this.min) {
            errors["minNum"] = true;
          }

          if (this.max !== undefined && value > this.max) {
            errors["maxNum"] = true;
          }
        }

        if (
          key == "denominator" &&
          this.fieldTracker[key] &&
          value !== null &&
          value !== undefined
        ) {
          if (this.min !== undefined && value < this.min) {
            errors["minDen"] = true;
          }

          if (this.max !== undefined && value > this.max) {
            errors["maxDen"] = true;
          }
        }
      }
    }
    // console.log( "Determined frequency errors:", errors );
    return Object.keys(errors).length == 0 ? undefined : errors;
  }

  numberOnly(event) {
    if (this.config.hospiceAideToggle && this.required && +event.key === 0) {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/inputs/frequency-input/frequency-input.ts